import React from 'react'
import { ThreeLayersIcon, TickIcon, TwoLayersIcon } from '../../../icons'
import Button from '../../../components/button/Button'

const FeatureKey = ({ text }) => {
    return (
        <div className="flex items-center gap-[12px] w-full">
            <TickIcon />
            <span className='text-[#475467]'>
                {text}
            </span>
        </div>
    )
}

const PricingSection = () => {
    return (
        <div className='flex items-start gap-[64px] max-w-[1980px] w-full flex-col py-[96px] px-[7.7vw]'>

            <div className="flex flex-col gap-[20px] items-start max-w-[768px] w-full max-md:text-center">
                <div className="flex flex-col gap-[12px] ">
                    <span className='text-[#1C9943] font-[600]'>
                        Pricing
                    </span>
                    <h2 className='text-[#101828] sm:text-[36px] text-[32px] font-[600]'>
                        Find the Right Plan for Your Needs
                    </h2>
                </div>
                <span className='text-[#475467] sm:text-[20px] text-[16px]'>
                    Explore our flexible pricing options to find the plan that best suits your needs.
                </span>
            </div>

            <div className="grid md:grid-cols-2 grid-cols-1 gap-[32px] w-full">

                <div className="flex flex-col pb-[32px] items-center bg-[#] border-[1px] border-[#EAECF0] rounded-[16px] w-full h-full">
                    <div className="flex flex-col gap-[32px] p-[32px] items-center w-full">
                        <div className="flex flex-col gap-[16px] items-center">
                            <div className="flex items-center justify-center p-[12px] rounded-full bg-[#1C9943] w-fit">
                                <TwoLayersIcon />
                            </div>
                            <span className='text-[20px] text-[#303030] font-[600]'>
                                Individual Treatments
                            </span>
                        </div>
                        <div className="flex flex-col gap-[16px] w-full">
                            <FeatureKey text={'Initial assessment – £75'} />
                            <FeatureKey text={'Follow up – £65'} />
                            <FeatureKey text={'Supplementary – £85'} />
                            <FeatureKey text={'Sports Massage – £65'} />
                            <FeatureKey text={'Acupuncture – £50'} />
                        </div>
                    </div>
                    <div className="flex items-center justify-center p-[32px] bg-[#F9FAFB] w-full">
                        <Button className={'w-full text-center'}>
                            Get started
                        </Button>
                    </div>
                </div>

                <div className="flex flex-col pb-[32px] items-center bg-[#] border-[1px] border-[#EAECF0] rounded-[16px] w-full h-full">
                    <div className="flex flex-col gap-[32px] p-[32px] items-center w-full h-full">
                        <div className="flex flex-col gap-[16px] items-center">
                            <div className="flex items-center justify-center p-[12px] rounded-full bg-[#1C9943] w-fit">
                                <ThreeLayersIcon />
                            </div>
                            <span className='text-[20px] text-[#303030] font-[600]'>
                                Block sessions
                            </span>
                        </div>
                        <div className="flex flex-col gap-[16px] w-full">
                            <FeatureKey text={'Four 1 hour block sessions – £220'} />
                            <FeatureKey text={'Ten 1 hour block sessions – £500'} />
                        </div>
                    </div>
                    <div className="flex items-center justify-center p-[32px] bg-[#F9FAFB] w-full">
                        <Button className={'w-full text-center'}>
                            Get started
                        </Button>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default PricingSection